import { FC, memo } from 'react'
import { IonBackButton } from '@ionic/react'
import { chevronBack } from 'ionicons/icons'

interface IBackButtonProps {
  defaultHref?: string
  className?: string
}

export const BackButtonComponent: FC<IBackButtonProps> = ({
  defaultHref = '',
  className,
}) => {
  return (
    <IonBackButton
      text=""
      mode="md"
      className={`ion-color ion-color-success ${className}`}
      defaultHref={defaultHref}
      icon={chevronBack}
    />
  )
}

export const BackButton = memo(BackButtonComponent)
